import { render, staticRenderFns } from "./UserSegmentPlayers.vue?vue&type=template&id=4ba96197&"
import script from "./UserSegmentPlayers.vue?vue&type=script&lang=js&"
export * from "./UserSegmentPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports